import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/embed/components/embed-gif-mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/embed/components/embed-gif.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/embed/components/related-gifs.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
